import type { RouteGroup } from '@martech-solution/utils/types';

// Import all route groups
import { commonRoutes } from './common.routes';
import { administrationRoutes } from './administration.routes';
import { masterDataRoutes } from './masterData.routes';
import { hrRoutes } from './hr.routes';
import { settingRoutes } from './setting.routes';
import { authRoutes, errorRoutes } from '@martech-solution/utils/routes';

// Export all individual route groups for selective use
export { commonRoutes, administrationRoutes, masterDataRoutes, hrRoutes, settingRoutes, authRoutes, errorRoutes };

// Export route types
export type { RouteType, RouteGroup } from './types';

// Combine all routes that require permission checks
export const routesCheckPermission: RouteGroup = [
  ...commonRoutes,
  ...administrationRoutes,
  ...masterDataRoutes,
  ...hrRoutes,
  ...settingRoutes
];

// Combine all routes (put V2 routes first for proper root path handling)
export const allRoutes: RouteGroup = [...authRoutes, ...errorRoutes, ...routesCheckPermission];

// Default export for convenience
export default allRoutes;
